import { render, staticRenderFns } from "./bizCardPage.vue?vue&type=template&id=1f198ecd&scoped=true&"
import script from "./bizCardPage.vue?vue&type=script&lang=js&"
export * from "./bizCardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f198ecd",
  null
  
)

export default component.exports